import React from 'react'
import LangSwitcher from './LangSwitcher'
import Icons from './Icons'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const Nav = ({ currentSection }) => {
  const handleClick = (event, link) => {
    event.preventDefault()
    document.getElementById(link).scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  const { t } = useTranslation()

  const menu = [
    {
      title: t('homeSection.title'),
      icon: 'home',
      link: 'section1'
    },
    {
      title: t('aboutSection.title'),
      icon: 'user',
      link: 'section2'
    },
    {
      title: 'Services',
      icon: 'suitcase',
      link: 'section3'
    },
    {
      title: 'Experience',
      icon: 'graduation',
      link: 'section4'
    },
    {
      title: t('reviewsSection.title'),
      icon: 'speech-bubble',
      link: 'section5'
    },
    {
      title: t('blogSection.title'),
      icon: 'notes',
      link: 'section6'
    },
    {
      title: 'Contact',
      icon: 'email',
      link: 'section7'
    }
  ]

  return <nav className="hidden lg:flex bg-martinique text-gray-400 border-r border-martinique-400 fixed top-0 left-0 w-32 h-screen text-center flex-col justify-start content-start items-center">
    <div id="logo" className="justify-self-start w-full">
        <LangSwitcher className="mx-auto mt-10" />
    </div>
    <div id="menu" className="flex flex-col justify-start justify-self-center mt-16">
      {menu.map((value, index) => {
        return <a key={index} className={`my-5 cursor-pointer ${currentSection === value.link ? 'text-yellow-400' : 'text-athens-gray-700 '}`} onClick={(e) => handleClick(e, value.link)}>
          <Icons name={value.icon} className="hover:text-white h-6 fill-current transition delay-300" />
        </a>
      })}
    </div>
    <div id="copy" className="justify-self-end w-full flex-1 relative text-sm">
      <p className="-rotate-90 transform absolute h-44 w-52 bottom-10 left-10">&copy; 2022 Alexandre Lion.</p>
    </div>
  </nav>
}

export default Nav
